(function () {
  function syncVideos(splide) {
    if (!splide || !splide.Components || !splide.Components.Elements) return;
    splide.Components.Elements.slides.forEach(function (slide, index) {
      slide.querySelectorAll('video').forEach(function (video) {
        if (index === splide.index) {
          if (video.hasAttribute('autoplay') || video.dataset.shouldAutoplay === 'true') {
            video.play().catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    });
  }

  function initVideoControls(root) {
    root.querySelectorAll('.image-content-hero-slide').forEach(function (slide) {
      var video = slide.querySelector('.image-content-hero-slide-video, video');
      var btn = slide.querySelector('.image-content-hero-slide-video-pause-btn');
      if (!video || !btn || btn.dataset.bound === 'true') return;

      btn.dataset.bound = 'true';

      var syncBtn = function () {
        var playing = !video.paused && !video.ended;
        btn.classList.toggle('is-playing', playing);
        btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      };

      video.addEventListener('play', syncBtn);
      video.addEventListener('pause', syncBtn);
      video.addEventListener('ended', syncBtn);
      syncBtn();

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    });
  }

  function initImageContentSlider(root) {
    if (!root || root.classList.contains('is-initialized') || typeof Splide === 'undefined') return;

    var slides = root.querySelectorAll('.splide__slide');
    initVideoControls(root);

    if (slides.length <= 1) {
      root.classList.add('is-initialized');
      root.style.visibility = 'visible';
      if (slides[0]) slides[0].style.flexShrink = 'initial';
      return;
    }

    var rewind = root.dataset.rewind === 'true';
    var splide = new Splide(root, {
      type: 'slide',
      rewind: rewind,
      perPage: 1,
      arrows: root.dataset.arrows === 'true',
      pagination: root.dataset.dots === 'true',
      speed: parseInt(root.dataset.speed, 10) || 800,
      autoplay: root.dataset.autoplay === 'true',
      interval: parseInt(root.dataset.interval, 10) || 5000,
      pauseOnHover: root.dataset.pauseOnHover === 'true',
      pauseOnFocus: root.dataset.pauseOnFocus === 'true'
    });

    splide.on('mounted move', function () {
      syncVideos(splide);
    });

    splide.mount();
    root.classList.add('is-initialized');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.image-content-slider').forEach(initImageContentSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
